export default {
  labels: {
    sold_out: 'Sold out!',
    most_popular: '#{{rank}} Most Liked',
  },
};
